export const UPDATE_ACTIVE_ITEM = 'GIFTYA/UPDATE_ACTIVE_ITEM';
export const UPDATE_ACTIVE_ITEM_SUCCESS = 'GIFTYA/UPDATE_ACTIVE_ITEM_SUCCESS';
export const UPDATE_ACTIVE_ITEM_FAILURE = 'GIFTYA/UPDATE_ACTIVE_ITEM_FAILURE';
export const RESET_UPDATE_ACTIVE_ITEM = 'GIFTYA/RESET_UPDATE_ACTIVE_ITEM';

export const FETCH_AWS_UPLOAD_DETAILS = 'GIFTYA/FETCH_AWS_UPLOAD_DETAILS';
export const FETCH_AWS_UPLOAD_DETAILS_SUCCESS = 'GIFTYA/FETCH_AWS_UPLOAD_DETAILS_SUCCESS';
export const FETCH_AWS_UPLOAD_DETAILS_FAILURE = 'GIFTYA/FETCH_AWS_UPLOAD_DETAILS_FAILURE';

export const UPLOAD_VIDEO = 'GIFTYA/UPLOAD_VIDEO';
export const UPLOAD_VIDEO_SUCCESS = 'GIFTYA/UPLOAD_VIDEO_SUCCESS';
export const UPLOAD_VIDEO_FAILURE = 'GIFTYA/UPLOAD_VIDEO_FAILURE';

export const START_VIDEO_TRANSCODE = 'GIFTYA/START_VIDEO_TRANSCODE';
export const START_VIDEO_TRANSCODE_SUCCESS = 'GIFTYA/START_VIDEO_TRANSCODE_SUCCESS';
export const START_VIDEO_TRANSCODE_FAILURE = 'GIFTYA/START_VIDEO_TRANSCODE_FAILURE';

export const CHECK_VIDEO_TRANSCODE_STATUS = 'GIFTYA/CHECK_VIDEO_TRANSCODE_STATUS';
export const CHECK_VIDEO_TRANSCODE_STATUS_SUCCESS = 'GIFTYA/CHECK_VIDEO_TRANSCODE_STATUS_SUCCESS';
export const CHECK_VIDEO_TRANSCODE_STATUS_FAILURE = 'GIFTYA/CHECK_VIDEO_TRANSCODE_STATUS_FAILURE';

export const RESET_CUSTOM_VIDEO_DIALOG = 'GIFTYA/RESET_CUSTOM_VIDEO_DIALOG';

export const UPLOAD_IMAGE_TO_S3 = 'GIFTYA/UPLOAD_IMAGE_TO_S3';
export const RESET_UPLOAD_IMAGE_TO_S3 = 'GIFTYA/RESET_UPLOAD_IMAGE_TO_S3';

export const UPLOAD_CUSTOM_PHOTO_TO_S3 = 'GIFTYA/UPLOAD_CUSTOM_PHOTO_TO_S3';
export const RESET_UPLOAD_CUSTOM_PHOTO_TO_S3 = 'GIFTYA/RESET_UPLOAD_CUSTOM_PHOTO_TO_S3';

export const updateActiveItem = (data) => ({
    type: UPDATE_ACTIVE_ITEM,
    data
});
export const updateActiveItemSuccess = (data) => ({
    type: UPDATE_ACTIVE_ITEM_SUCCESS,
    data
});
export const updateActiveItemFailure = () => ({
    type: UPDATE_ACTIVE_ITEM_FAILURE
});
export const resetUpdateActiveItem = () => ({
    type: RESET_UPDATE_ACTIVE_ITEM
});


export const fetchAwsUploadDetails = () => ({
    type: FETCH_AWS_UPLOAD_DETAILS
});
export const fetchAwsUploadDetailsSuccess = (data) => ({
    type: FETCH_AWS_UPLOAD_DETAILS_SUCCESS,
    data
});
export const fetchAwsUploadDetailsFailure = () => ({
    type: FETCH_AWS_UPLOAD_DETAILS_FAILURE
});


export const uploadVideo = (url, file) => ({
    type: UPLOAD_VIDEO,
    url,
    file
});
export const uploadVideoSuccess = (data) => ({
    type: UPLOAD_VIDEO_SUCCESS,
    data
});
export const uploadVideoFailure = () => ({
    type: UPLOAD_VIDEO_FAILURE
});


export const startVideoTranscode = (fileName) => ({
    type: START_VIDEO_TRANSCODE,
    fileName
});
export const startVideoTranscodeSuccess = (data) => ({
    type: START_VIDEO_TRANSCODE_SUCCESS,
    data
});
export const startVideoTranscodeFailure = () => ({
    type: START_VIDEO_TRANSCODE_FAILURE
});


export const checkVideoTranscodeStatus = (id) => ({
    type: CHECK_VIDEO_TRANSCODE_STATUS,
    id
});
export const checkVideoTranscodeStatusSuccess = (data) => ({
    type: CHECK_VIDEO_TRANSCODE_STATUS_SUCCESS,
    data
});
export const checkVideoTranscodeStatusFailure = () => ({
    type: CHECK_VIDEO_TRANSCODE_STATUS_FAILURE
});


export const resetCustomVideoDialog = () => ({
    type: RESET_CUSTOM_VIDEO_DIALOG
});


export const uploadImageToS3 = (payload, meta, error) => ({
    type: UPLOAD_IMAGE_TO_S3,
    payload,
    meta,
    error
});
export const resetUploadImageToS3 = (payload, meta, error) => ({
    type: RESET_UPLOAD_IMAGE_TO_S3,
    payload,
    meta,
    error
});


export const uploadCustomPhotoToS3 = (payload, meta, error) => ({
    type: UPLOAD_CUSTOM_PHOTO_TO_S3,
    payload,
    meta,
    error
});
export const resetUploadCustomPhotoToS3 = (payload, meta, error) => ({
    type: RESET_UPLOAD_CUSTOM_PHOTO_TO_S3,
    payload,
    meta,
    error
});